import React from "react";
import SalaryDetailsInfo from "./SalaryDetailsInfo";


const SalaryInfo = ({ employee }) => {
  
  return (
   <div>
    <SalaryDetailsInfo employee={employee} />
   </div>
  );
};

export default SalaryInfo;
